import { helpAddFileExtends } from '../../app/services/FileExtends/helpAddFileExtend'
import { helpDeleteFileExtends } from '../../app/services/FileExtends/helpDeleteFileExtend'
import { helpGetFileExtends } from '../../app/services/FileExtends/helpGetFileExtends'
import { logEvent } from '../../utils/LogEvents'
import { setErrorTextSnackBar, setRequestTextSnackBar } from './app'

// ---------------------
// SECURITY - FILE EXTENSIONS API
// ---------------------

// request get all file extensions
export const getAllFileExtends = () => {
  return async (dispatch) => {
    try {
      const response = await helpGetFileExtends()
      return response.data?.data?.docs
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: FileExtensions'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en el servicio: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      return []
    }
  }
}

// add file extension
export const addFileExtends = (extension) => {
  return async (dispatch) => {
    try {
      const response = await helpAddFileExtends(extension)
      await logEvent('CGI - create', {
        body: extension,
        response: response
      })

      return response
    } catch (error) {
      await logEvent('CGI - create', {
        body: extension,
        response: error
      })

      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: FileExtensions'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en el servicio: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      return error
    }
  }
}
// delete file extension
export const deleteFileExtends = (extension) => {
  return async (dispatch) => {
    try {
      const response = await helpDeleteFileExtends(extension)
      await logEvent('CGI - delete', {
        body: extension,
        response: response
      })

      return response
    } catch (error) {
      await logEvent('CGI - delete', {
        body: extension,
        response: error
      })
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: FileExtensions'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en el servicio: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      return error
    }
  }
}
